export default "__VITE_ASSET__BpvJjkq5__"